import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const aemApiConfig = window.lt.api.ltAemApi as ltFramework.IDictionary;

export const memberConfig = window.lt.api.member as ltFramework.IDictionary;

export const sfWebToLead = window.lt.api.sfWebToLead as ltFramework.IDictionary;
